import React from "react";
import { useContext } from "react";

import StoreContext from "../../Store/code-context";
import classes from "./Header.module.css";

export default function Header() {
  const storeCtx = useContext(StoreContext);
  const clickHandler = () => {
    storeCtx.IsFile(false);
    storeCtx.setPrefix("");
  };
  const onselectHandler = () => {
    storeCtx.IsDark((prev) => !prev);
  };
  return (
    <header className={classes.header}>
      <div className={classes.container}>
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className={classes.logo}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.042 21.672L13.684 16.6m0 0l-2.51 2.225.569-9.47 5.227 7.917-3.286-.672zM12 2.25V4.5m5.834.166l-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243l-1.59-1.59"
            />
          </svg>
        </span>
        <h1 className={classes.mainHeading}>CodeEditor</h1>
      </div>
      {!storeCtx.File && (
        <input
          className={classes.inputbox}
          placeholder="Search File Here ... "
        />
      )}
      {storeCtx.File && (
        <div className={classes.buttonContainer}>
          <button
            className={classes.button}
            style={
              storeCtx.Dark
                ? { background: "#eee", color: "#444444" }
                : { background: "#34495e" }
            }
            onClick={onselectHandler}
          >
            {storeCtx.Dark ? "Light" : "Dark"}
          </button>
          <button className={classes.button} onClick={clickHandler}>
            Home
          </button>
        </div>
      )}
    </header>
  );
}
